import React from 'react';
import { useTheme } from 'styled-components';

import { getColor } from '../../V2/Elements/Icons/helpers.ts';
import type { IIcon } from './types.ts';

const Icon = React.forwardRef<SVGSVGElement | null, IIcon>(function Icon({ size = 24, alt, color, className, onClick }, ref) {
  const theme = useTheme();
  const fillColor = React.useMemo(() => getColor({ color, alt, theme }), [color, alt, theme]);
  return (
    <svg ref={ref} onClick={onClick} width={size} height={size} viewBox='0 0 512 512' className={className} fill={fillColor}>
      <g>
        <g>
          <path d='m339.7,246.2c0-11.3-9.1-20.4-20.4-20.4h-185.3c-11.3,0-20.4,9.1-20.4,20.4 0,11.3 9.1,20.4 20.4,20.4h185.3c11.3,5.68434e-14 20.4-9.1 20.4-20.4z' />
          <path d='m500.6,236.5c-2.1-11.1-12.8-18.3-23.9-16.3-13.5,2.6-26.9,7-40.2,12.7v-129.9c0-28.1-22.9-51-51-51h-141.3v-20.6c0-11.3-9.1-20.4-20.4-20.4s-20.4,9.1-20.4,20.4v20.5h-141.4c-28.1,0-51,22.9-51,51v347c0,28.1 22.9,51 51,51h323.5c28.1,0 51-22.9 51-51v-171.7c15.8-8.5 31.9-14.9 47.8-17.9 11.2-2 18.4-12.7 16.3-23.8zm-183.4-143.8l-14.6,28.9h-157.5l-14.6-28.9h186.7zm78.6,357.3c0,5.6-4.6,10.2-10.2,10.2h-323.6c-5.6,0-10.2-4.6-10.2-10.2v-347c0-5.6 4.6-10.2 10.2-10.2h22.6l29.6,58.5c3.5,6.9 10.5,11.2 18.2,11.2h182.6c7.7,0 14.7-4.3 18.2-11.2l29.6-58.5h22.6c5.6,0 10.2,4.6 10.2,10.2v152.3c-56.1,36.4-104,90.2-127.8,119.2l-28.6-33.7c-7.3-8.6-20.2-9.7-28.8-2.4-8.6,7.3-9.7,20.2-2.4,28.8l45,52.8c3.9,4.6 9.6,7.2 15.6,7.2 0.2,0 0.5,0 0.7,0 6.2-0.2 12.1-3.3 15.7-8.3 0.7-1 49.4-66.8 110.7-113.8v144.9z' />
        </g>
        <path stroke={fillColor} strokeLinejoin='round' strokeLinecap='round' strokeWidth='66.667' d='m256,256' strokeMiterlimit='10' />
      </g>
    </svg>
  );
});

export default React.memo(Icon);
